import Block from './Block'

export default class SocialMedia extends Block {
  getElems() {
    super.getElems()

    this.socialToggler = this.el.querySelector('.social-media__toggler')
  }

  events() {
    super.events()

    this.socialToggler.addEventListener('click', this.toggle.bind(this))
  }

  toggle() {
    this.el.classList.toggle('active')
  }

  destroy() {
    super.destroy()

    this.socialToggler.removeEventListener('click', this.toggle)
  }
}
